import {IPlayerMessagesService} from "./player-messages.service.interface";
import {ServiceBase} from "../ServiceBase";
import {delay} from "../../../utils/delay";
import {TimeSpan} from "@sparkware/app-utils";
import {isInsideAutomation} from "../../../utils/automation-helpers";

export class PlayerMessagesService extends ServiceBase implements IPlayerMessagesService {

    waitForPlayerMessagesReady(): Promise<void> {
        if(this.services.sdk.isPlayerMessagesConnected) {
            return Promise.resolve();
        }

        return new Promise<void>(resolve => {
            const subscription = this.services.sdk.events.onPlayerMessagesConnected(async () => {
                subscription?.off();
                if(!isInsideAutomation()) { //TODO - remove this if and fix the tests
                    await delay(TimeSpan.fromSeconds(1));
                }

                resolve();
            })
        });
    }

}